import script from "./ContentPayableMixin.vue?vue&type=script&lang=js"
export * from "./ContentPayableMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__